/**
 * Quick Actions Block Script
 *
 * This script initializes the dropdown menu for the Quick Actions block.
 *
 * @return {void}
 */
function initQuickActionsBlock() {
	const quickActions = document.querySelectorAll('.quick-actions');

	quickActions.forEach((quickAction) => {
		const actionForm = quickAction.querySelector('.quick-actions-dropdown');
		if (!actionForm) {
			return;
		}

		const actionButton = quickAction.querySelector(
			'.quick-actions-dropdown__button'
		);
		actionButton.addEventListener('click', () => {
			const selectedOption = actionForm.querySelector(
				'.quick-actions-dropdown__select'
			).selectedOptions[0];
			const actionUrl = selectedOption.value;
			const actionTarget = selectedOption.dataset.target;

			// Open in new tab/window if target is _blank.
			if (actionTarget === '_blank') {
				window.open(actionUrl, '_blank', 'noopener, noreferrer');
				return;
			}
			// Otherwise, navigate to the URL normally.
			window.location.href = actionUrl;
		});
	});
}

document.addEventListener('DOMContentLoaded', function () {
	initQuickActionsBlock();
});
